import { Injectable, Injector, Inject, PLATFORM_ID } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';
import { TokenService } from '../token.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        private inj: Injector,
        @Inject(PLATFORM_ID) private platformId
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Get the auth header from the service.
        const auth = this.inj.get(TokenService);

        // Clone the request to add the new header.

        let headers = req.headers;
        if (isPlatformBrowser(this.platformId)) {
            headers = req.headers.set('Authorization', 'Bearer ' + auth.get());
            headers.append('Cache-Control', 'no - cache');
            headers.append('Pragma', 'no - cache');
            //headers.append('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');
        }

        const authReq = req.clone({ headers });
        // Pass on the cloned request instead of the original request.
        return next.handle(authReq);
    }
}
